import { Control } from '@yleisradio/areena-types';
import React from 'react';
import Icon from 'assets/chevronLeft.svg';
import { useTranslation } from 'hooks/useTranslation';
import { Button } from '..';
import styles from './SeriesLink.module.scss';

interface SeriesLinkProps {
  control: Control;
  disabled?: boolean;
  onClick?: React.MouseEventHandler | undefined;
  dataTestId?: string | undefined;
}

export const SeriesLink: React.FunctionComponent<SeriesLinkProps> = ({
  control,
  disabled = false,
  onClick,
  dataTestId,
}) => {
  const t = useTranslation();
  const ariaLabel = `${t('backToSeries')} ${control.title || ''}`;

  return (
    <div className={styles.seriesLinkWrapper}>
      <Button
        pointer={control.destination}
        dataTestId={dataTestId}
        text={control.title || ''}
        disabled={disabled}
        iconLeft={Icon}
        onClick={onClick}
        variant="text"
        padding="vertical"
        size="sm"
        aria-label={ariaLabel}
      />
    </div>
  );
};
